import * as React from "react";
import { StatefulTabs as BaseStatefulTabs, Tab, StatefulTabsProps } from "baseui/tabs";
import { expandBorderRadius } from "../utils/styles";

const StatefulTabs: React.FC<StatefulTabsProps> = (props) => (
  <BaseStatefulTabs overrides={overrides} {...props} />
);

const overrides: StatefulTabsProps["overrides"] = {
  TabBar: {
    style: ({ $theme }) => ({
      backgroundColor: "none",
      justifyContent: "center",
      [$theme.mediaQuery.medium]: {
        justifyContent: "flex-start",
      },
    }),
  },
  Tab: {
    style: ({ $theme, $active }) => {
      return {
        backgroundColor: $active ? $theme.colors.mono600 : $theme.colors.white,
        color: $active ? $theme.colors.white : $theme.colors.contentPrimary,
        height: "24px",
        ...expandBorderRadius("12px"),
        borderBottom: "none",
        paddingTop: "2px",
        paddingBottom: "2px",
        paddingLeft: "16px",
        paddingRight: "16px",
        textTransform: "uppercase",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px",
        ":hover": {
          backgroundColor: $active ? $theme.colors.mono700 : $theme.colors.mono300,
          color: $active ? $theme.colors.white : $theme.colors.contentPrimary,
        },
        ":focus": {
          backgroundColor: $active ? $theme.colors.mono600 : $theme.colors.white,
          color: $active ? $theme.colors.white : $theme.colors.contentPrimary,
        },
      };
    },
  },
};

export { StatefulTabs, Tab };
